module.exports = __webpack_public_path__ + "static/img/fun1.2a310e78.png";